// assets/variant-updater.js

console.log("Variant updater script loaded");

document.addEventListener("DOMContentLoaded", function() {
  // We werken per product; begin bij het .product element
  var productElement = document.querySelector('.product');
  if (!productElement) {
    console.warn('variant-updater: geen .product element gevonden');
    return;
  }

  var productTitle = document.getElementById("product-title");
  var variantDescriptionAccordion = document.getElementById("variant-description-accordion");
  var variantDescriptionTab = document.getElementById("variant-description");
  var specTitle = document.getElementById('variant-spec-title');
  var specTables = document.querySelectorAll('.spec-table');

  // Alle varianten uit de JSON in de pagina
  var variants = [];
  var variantsJsonEl = document.getElementById("product-variants-json");
  if (variantsJsonEl) {
    try {
      variants = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {
      console.error("variant-updater: kon product-variants-json niet parsen", e);
    }
  } else {
    console.warn("variant-updater: #product-variants-json niet gevonden");
  }

  console.log("variant-updater: geladen varianten:", variants);

  function getVariantById(id) {
    return variants.find(function(v) {
      return v.id == id;
    });
  }

  function updateTitle(variant) {
    if (!productTitle) {
      console.warn("variant-updater: productTitle element niet gevonden");
      return;
    }

    var baseTitle =
      productTitle.getAttribute("data-product-title") ||
      productTitle.textContent.trim();

    if (variants.length > 1 && variant && variant.title && variant.title !== "Default Title") {
      productTitle.textContent = baseTitle + " - " + variant.title;
    } else {
      productTitle.textContent = baseTitle;
    }

    console.log("variant-updater: titel bijgewerkt naar:", productTitle.textContent);
  }

  function formatDescription(description) {
    if (!description) return '';

    var lines = description.split('\n');
    var formattedDescription = '';
    var isHeader = false;

    lines.forEach(function(line, index) {
      line = line.trim();
      if (line) {
        if (
          line.length < 50 &&
          !line.endsWith('.') &&
          index < lines.length - 1 &&
          lines[index + 1].trim()
        ) {
          formattedDescription += '<b class="product-description-header">' + line + '</b><br>';
          isHeader = true;
        } else {
          if (isHeader) {
            formattedDescription += '<p>' + line + '</p>';
          } else {
            formattedDescription += line + '<br>';
          }
          isHeader = false;
        }
      } else {
        formattedDescription += '<br>';
      }
    });

    return formattedDescription;
  }

  function updateDescription(variant) {
    if (!variant) return;

    var descriptionElement = document.getElementById("variant-description-" + variant.id);
    if (!descriptionElement) {
      console.warn("variant-updater: geen description element voor variant", variant.id);
      return;
    }

    var description = descriptionElement.getAttribute("data-description") || '';
    description = formatDescription(description);

    if (variantDescriptionAccordion) {
      variantDescriptionAccordion.innerHTML = description;
    }
    if (variantDescriptionTab) {
      variantDescriptionTab.innerHTML = description;
    }

    console.log("variant-updater: description bijgewerkt voor variant:", variant.id);
  }

  function updateFixedRows(table, variant) {
    if (!table || !variant) return;

    // Rij 0, kolom 1: SKU
    if (table.rows[0] && table.rows[0].cells[1]) {
      table.rows[0].cells[1].textContent = variant.sku || 'N/A';
    }

    // Rij 1, kolom 1: EAN / barcode
    if (table.rows[1] && table.rows[1].cells[1]) {
      table.rows[1].cells[1].textContent = variant.barcode || 'N/A';
    }
  }

  function updateVariantSpecs(variant) {
    if (!variant) {
      console.error("variant-updater: variant is undefined in updateVariantSpecs");
      return;
    }

    console.log("variant-updater: specs bijwerken voor variant:", variant.id);

    specTables.forEach(function(table) {
      if (table.id === "spec-table-" + variant.id) {
        table.style.display = 'table';
        if (specTitle) {
          specTitle.textContent = "Specifications for " + (variant.title || '');
        } else {
          console.warn("variant-updater: specTitle element niet gevonden");
        }
        updateFixedRows(table, variant);
      } else {
        table.style.display = 'none';
      }
    });
  }

  function populateSpecTables() {
    specTables.forEach(function(table) {
      var parts = table.id.split('-');
      var variantId = parts[parts.length - 1];
      var specDataElement = document.getElementById("spec-data-" + variantId);

      if (specDataElement) {
        try {
          var specs = JSON.parse(specDataElement.textContent);
          var tbody = table.querySelector('tbody');

          // bewaar de eerste 2 vaste rijen (SKU & EAN)
          for (var i = tbody.rows.length - 1; i >= 2; i--) {
            tbody.deleteRow(i);
          }

          specs.forEach(function(spec) {
            var row = tbody.insertRow();
            var cell1 = row.insertCell(0);
            var cell2 = row.insertCell(1);

            cell1.innerHTML = "<strong>" + spec.name + "</strong>";
            cell1.className = 'spec-name';

            var value = Array.isArray(spec.value) ? spec.value.join(', ') : spec.value;
            cell2.textContent = value;
            cell2.className = 'spec-value';
          });
        } catch (error) {
          console.error('variant-updater: fout bij parsen spec data:', error);
        }
      }
    });
  }

  function applyVariant(variant) {
    if (!variant) return;

    updateTitle(variant);
    updateDescription(variant);
    updateVariantSpecs(variant);

    // eigen custom event voor als andere scripts willen meekijken
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
  }

  function initFromCurrentVariant() {
    // gebruik de hidden input name="id" die het theme bijhoudt
    var idInput = productElement.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) {
      console.warn("variant-updater: geen input[name='id'] gevonden voor huidige variant");
      return;
    }

    var currentVariant = getVariantById(idInput.value);
    if (!currentVariant) {
      console.warn("variant-updater: huidige variant niet gevonden in variants JSON", idInput.value);
      return;
    }

    console.log("variant-updater: initial variant:", currentVariant.id);
    applyVariant(currentVariant);
  }

  // 1️⃣ Specificatie-tabellen eenmalig vullen
  console.log("variant-updater: populateSpecTables()");
  populateSpecTables();

  // 2️⃣ Luisteren naar theme's variant-picker event
  var variantPicker = productElement.querySelector('variant-picker');
  if (variantPicker) {
    variantPicker.addEventListener('on:variant:change', function(evt) {
      console.log("variant-updater: on:variant:change ontvangen", evt.detail);

      if (evt.detail && evt.detail.variant) {
        applyVariant(evt.detail.variant);
      } else {
        // fallback: pak de huidige variant via hidden input
        initFromCurrentVariant();
      }
    });
  } else {
    console.warn("variant-updater: geen <variant-picker> gevonden binnen .product");
  }

  // 3️⃣ Initiale variant instellen op pageload
  initFromCurrentVariant();
});